import { METER_COLOR_PALETTE } from "@next-platform/packages-ts-types";
import resolveMeterColor from "../resolveMeterColor";
/** Combined rules (and hidden meters) set the mood without a visible meter of their own. */
export const COMBINED_MOOD_COLOR = METER_COLOR_PALETTE.purple.light;
/** A visible meter without a color of its own. */
const NEUTRAL_MOOD_COLOR = "#AAAAAA";
/**
 * The "Right now" mood line and the color of its dot: the color of the visible meter whose level supplied the
 * caption (neutral grey when it has no color), else the combined-rule purple. `null` when there is no caption.
 */
export default function resolveHudMood({ rulebook, snapshot, theme = "light", }) {
    const hudCaption = snapshot.meta.caption;
    if (!hudCaption) {
        return null;
    }
    const caption = hudCaption.text;
    // `meter_id` is `null` for a combined rule or a hidden meter; a visible source meter colors the dot.
    const source = hudCaption.meter_id === null ? undefined : (rulebook.meters ?? []).find((meter) => meter.id === hudCaption.meter_id);
    if (!source) {
        return { caption, color: METER_COLOR_PALETTE.purple[theme] };
    }
    return { caption, color: resolveMeterColor({ color: source.color, theme }) ?? NEUTRAL_MOOD_COLOR };
}
